import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Footer = styled.footer(({ style }) => ({
    width: '100%',
  '.container': { width: '100%', marginLeft: 'auto', marginRight: 'auto' },
  '@media (min-width: 768px)': {
    '.col-sm-12': { width: '50%' },
    '.one-column': { '.col-sm-12': { width: '100%' } }
  },
  '@media only screen and (min-width: 992px)': {
    '.container': { maxWidth: '100%' }
  },
  '@media only screen and (min-width: 1024px)': {
    '.container': { maxWidth: '994px !important' }
  },
  '@media only screen and (min-width: 1280px)': {
    '.container': { maxWidth: '1240px !important' }
  },
  ...style
}))

const Wrapper = styled.div(({ style }) => ({
  paddingLeft: '8.33%',
  paddingRight: '8.33%',
  paddingTop: '60px',
  '.row:first-child > div:nth-last-child(1) > div': {
    marginLeft: '80px',
    '@media only screen and (max-width: 768px)': { marginLeft: '0px' }
  },
  '.subtitle-two': {
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    lineHeight: '24px',
    color: 'inherit'
  },
  '.caption-text-one,\n  .caption-text-one a': {
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 500,
    color: 'inherit'
  },
  '.caption-text-one a': {
    letterSpacing: '0',
    textDecoration: 'none',
    borderBottom: '1px solid black'
  },
  '.columncontrolmobile': { display: 'block', marginTop: '30px' },
  '.columncontrol': { display: 'none' },
  '.col-nested': {
    a: {
      textDecoration: 'none',
      color: 'inherit',
      fontSize: '12px',
      letterSpacing: '0.5px',
      lineHeight: '20px',
      borderBottom: '0',
      fontWeight: 400,
      display: 'block',
      paddingBottom: '20px'
    },
    li: { paddingBottom: '0px !important' }
  },
  '@media only screen and (min-width: 768px)': {
    paddingTop: '100px',
    '.col-nested': { a: { paddingBottom: '10px' } },
    '.columncontrol': { display: 'block' },
    '.columncontrolmobile': { display: 'none' }
  },
  '@media only screen and (max-width: 671px)': {
    "div[class^='col-']": { paddingLeft: '0px', paddingRight: '0px' }
  },
  ...style
}))

const vStyle = {
  v2: {
    footer: {
      fontFamily: "'Open Sans', sans-serif",
      background: 'var(--black-raisin)',
      color: 'var(--white) !important'
    }
  },
  v3: {
    footer: {
      '--headingFont': "'Josefin Sans', sans-serif",
      '--bodyFont': "'Lato', sans-serif",
      background: 'var(--blue)',
      color: 'var(--white) !important'
    }
  },
  v4: {
    footer: {
      lineHeight: 'normal',
      borderTop: '1px solid var(--clr-grey-6-to-white)',
    }
  }
}

const FooterWrapper = ({ children, version }) => {
  const { footer, wrapper } = vStyle[version] || {}
  return (
    <Footer className="container-fluid pl-0 pr-0" style={footer}>
      <Wrapper
        data-gtm-placement="footer"
        className="container p-9"
        style={wrapper}
      >
        {children}
      </Wrapper>
    </Footer>
  )
}

FooterWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  version: PropTypes.string
}

export default FooterWrapper



// WEBPACK FOOTER //
// ./src/components/Footer/FooterWrapper.js